import { useCallback } from 'react';

import ProductSelect from 'components/ProductSelect';
import { useField } from 'formik';

import type { IProductSelectfieldsProps } from './types';

export default function ProductSelectField({
  name,
  disabled,
  location,
  subGroup,
  onChange = () => {},
  textFieldProps,
  productType,
}: IProductSelectfieldsProps) {
  const [{ value }, metaId, { setValue, setTouched }] = useField(name);

  const hasError = Boolean(metaId.touched && metaId.error);
  const helperText = hasError ? metaId.error : '';

  const handleOnBlur = useCallback(async () => {
    if (!metaId.touched) await setTouched(true, false);
  }, [setTouched, metaId]);

  const handleChange = useCallback(
    async (value) => {
      const newVal = value ? value.packagedItemReference : '';

      await setValue(newVal, true);
      onChange(newVal);
    },
    [onChange, setValue],
  );

  return (
    <ProductSelect
      productType={productType}
      disabled={disabled}
      location={location}
      selectedProductReference={value}
      onChange={handleChange}
      subGroup={subGroup}
      textFieldProps={{
        name: name,
        error: hasError,
        helperText: helperText,
        onBlur: handleOnBlur,
        ...textFieldProps,
      }}
    />
  );
}
